import styled from 'styled-components';

export const StyledHeader = styled.header`
  display: flex;
  justify-content: center;
  /* align-items: flex-start; */
  background-color: #c45634;
  width: 100%;
  height: 40px;
  /* padding: 10px 0; */
`;

export const StyledImg = styled.img`
  width: 500px;
  padding: 10px 0 20px 0;
`;
